import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      const redirect = location.state?.from || (user.role === "admin" ? "/admin" : "/dashboard");
      navigate(redirect);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-6 sm:px-12 lg:px-24 py-24 max-w-md mx-auto">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600 mb-3">// Vendor Login</div>
      <h1 className="font-display font-black uppercase tracking-tighter text-4xl text-slate-50 mb-8">Sign in</h1>

      <form onSubmit={submit} className="space-y-5 bg-slate-900 border border-slate-800 p-8 rounded-sm">
        <div>
          <label className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2 block">Email</label>
          <input
            data-testid="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2.5 bg-slate-950 border border-slate-700 text-slate-50 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none rounded-sm"
          />
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2 block">Password</label>
          <input
            data-testid="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2.5 bg-slate-950 border border-slate-700 text-slate-50 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none rounded-sm"
          />
        </div>
        <button
          data-testid="login-submit"
          disabled={loading}
          className="w-full py-3 bg-orange-600 text-white font-bold uppercase tracking-wider hover:bg-orange-500 disabled:opacity-50 rounded-sm"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
        <div className="text-sm text-slate-400 text-center pt-2">
          New vendor? <Link to="/register" className="text-orange-500 font-semibold">Create account</Link>
        </div>
      </form>
    </div>
  );
}
